<app-dialog
  [title]="data.title"
  [actions]="[
    { text: 'Ok'}
  ]"
  (action)="action($event)"
  (close)="action($event)"
>
  <div class="body_modal_logistics">
    <form>
      <div class="row m-0">
        <div class="shipment_status-actions_value col-sm-6">
            <span>Name</span>
            <span class="gray_text">{{data.companyDetails.fullName }}</span>
          </div>
          <div class="shipment_status-actions_value col-sm-6">
            <span>Company Name</span>
            <span class="gray_text">{{data.companyDetails.companyName }}</span>
          </div>
          <div class="shipment_status-actions_value col-sm-6">
            <span>Email</span>
            <span class="gray_text">{{data.companyDetails.email }}</span>
          </div>
          <div class="shipment_status-actions_value col-sm-6">
            <span>Phone Number</span>
            <span class="gray_text">{{data.companyDetails.phone}}</span>
          </div>
      </div>
    </form>
  </div>
</app-dialog>

